import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-stats',
  templateUrl: './general-stats.component.html',
  styleUrls: ['./general-stats.component.scss']
})
export class GeneralStatsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
